// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"306":"eabfb4c9","1105":"78478c23","4714":"195c23e3","6753":"7889e38e","6775":"50fb5d81","6873":"5547002f","6996":"31d6cfe0","7955":"2344cb75","9254":"6071660f"}[chunkId] + ".chunk.css";
};